export const stepList = [
  {
    name: 'Выезд на объект',
    text: 'Равным образом новая модель организационной деятельности позволяет оценить значение модели развития. ',
  },
  {
    name: 'Визуализация',
    text: 'Идейные соображения высшего порядка, а также рамки и место обучения кадров позволяет оценить значение новых предложений',
  },
  {
    name: 'Разработка',
    text: 'Равным образом новая модель организационной деятельности позволяет оценить значение модели развития.',
  },
  {
    name: 'Выезд на объект',
    text: 'Равным образом новая модель организационной деятельности позволяет оценить значение модели развития.',
  },
  {
    name: 'Визуализация',
    text: 'Идейные соображения высшего порядка, а также рамки и место обучения кадров позволяет оценить значение новых предложений',
  },
  {
    name: 'Разработка',
    text: 'Равным образом новая модель организационной деятельности позволяет оценить значение модели развития.',
  },
];
